<template>
  <div class="attendance-details">
    <div class="table-main">
      <div class="table-header">
        <div class="table-header-picker">
          <span>操作时间</span>
          <el-date-picker
            v-model="filterObj.begin_time"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
          />
          <i>至</i>
          <el-date-picker
            v-model="filterObj.end_time"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
          />
          <el-button type="primary" @click="searchData">查询</el-button>
          <el-button type="success" @click="exportExcel">导出Excel表</el-button>
        </div>
        <div class="table-header-pagination flex-wrap">
          <div class="header-left-total">
            <span>课耗天数：{{ consume_day_num }}天</span>
            <span>签到天数：{{ sign_num }}天</span>
            <span>请假天数：{{ pause_num }}天</span>
            <span>停课天数：{{ stop_num }}天</span>
          </div>
          <div>
            <el-pagination
              :current-page.sync="p"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="limit"
              layout="sizes, prev, slot, next"
              prev-text="上一页"
              next-text="下一页"
              :total="itemTotal"
              @size-change="handleSizeChange"
            >
              <div class="chax">
                {{ p }}/{{ itemTotal > 0 ? Math.ceil(itemTotal / limit) : 1 }}
              </div>
            </el-pagination>
          </div>
        </div>
      </div>
      <div class="table-body">
        <el-table
          :data="showList"
          border
          stripe
          :header-cell-style="{
            background: '#4c84ff',
            color: '#fff',
            height: '60px',
            textAlign: 'center'
          }"
        >
          <el-table-column prop="create_time" label="日期" align="center">
            <template slot-scope="scope">
              <span :class="scope.row.consume_day == 1 ? '' : 'italic-gray'">{{
                scope.row.create_time.substr(0, 11)
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="签到出勤状态" align="center">
            <template slot-scope="scope">
              <span :class="scope.row.consume_day == 1 ? '' : 'italic-gray'">{{
                scope.row.type == "not_in"
                  ? "未签到"
                  : scope.row.type == "hold"
                    ? "待开课"
                    : scope.row.type == "pause"
                      ? "请假"
                      : scope.row.type == "stop"
                        ? "停课"
                        : "已签到"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="consume_day" label="课耗状态" align="center">
            <template slot-scope="scope">
              <span :class="scope.row.consume_day == 1 ? '' : 'italic-gray'">{{
                scope.row.consume_day == 1 ? "已消耗" : "未消耗"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="timer_status"
            label="对应扣费方式"
            align="center"
          >
            <template slot-scope="scope">
              <span :class="scope.row.consume_day == 1 ? '' : 'italic-gray'">{{
                timeStatus[scope.row.timer_status]
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="headmaster_name" label="班主任" align="center">
            <template slot-scope="scope">
              <span :class="scope.row.consume_day == 1 ? '' : 'italic-gray'">{{
                scope.row.headmaster_name
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="selling_item_display"
            label="对应套餐名称"
            align="center"
          >
            <template slot-scope="scope">
              <span :class="scope.row.consume_day == 1 ? '' : 'italic-gray'">{{
                scope.row.selling_item_display
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="billing_id"
            label="对应订单编号"
            align="center"
            width="230"
          >
            <template slot-scope="scope">
              <span :class="scope.row.consume_day == 1 ? '' : 'italic-gray'">{{
                scope.row.billing_id
              }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-footer">
        <div class="block">
          <el-pagination
            layout="prev, pager, next, slot, jumper"
            :current-page.sync="p"
            prev-text="上一页"
            next-text="下一页"
            :total="itemTotal"
            :page-size="limit"
          >
            <div class="chax">
              {{ p }}/{{ itemTotal > 0 ? Math.ceil(itemTotal / limit) : 1 }}
            </div>
          </el-pagination>
          <div class="insert">
            <el-button type="primary">确定</el-button>
            <span class="pagination-count">
              符合查询结果:
              <i>{{ itemTotal }}条</i>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commondata from '@/utils/commondata'
import Tool from '@/assets/js/tool.js'

export default {
  name: 'AttendanceDetails',
  components: {},
  data() {
    return {
      filterObj: {
        child_id: '',
        begin_time: '',
        end_time: ''
      },
      itemList: [],
      showList: [],
      limit: 10,
      p: 1,
      itemTotal: 0,
      consume_day_num: 0,
      pause_num: 0,
      sign_num: 0,
      stop_num: 0,
      timeStatus: commondata.TIME_STATUS
    }
  },
  computed: {},
  watch: {
    p() {
      this.showList = this.itemList.slice(
        (this.p - 1) * this.limit,
        (this.p - 1) * this.limit + this.limit
      )
    }
  },
  mounted() {
    this.filterObj.child_id = this.$route.query.child_id
    this.filterObj.begin_time = Tool.formatTime(
      new Date() - 86400 * 1000 * 30,
      'date'
    )
    this.filterObj.end_time = Tool.formatTime(new Date(), 'date')
    this.getInfoAttendance(this.filterObj)
  },
  methods: {
    async getInfoAttendance(filterObj) {
      const ret = await this.$http.getInfoAttendance(filterObj)
      if (ret.code == 200) {
        this.itemTotal = ret.data.list.length
        this.itemList = ret.data.list
        this.showList = this.itemList.slice(
          (this.p - 1) * this.limit,
          (this.p - 1) * this.limit + this.limit
        )
        this.consume_day_num = ret.data.consume_day_num
        this.pause_num = ret.data.pause_num
        this.sign_num = ret.data.sign_num
        this.stop_num = ret.data.stop_num
      }
    },
    handleSizeChange(val) {
      this.limit = val
      this.showList = this.itemList.slice(
        (this.p - 1) * this.limit,
        (this.p - 1) * this.limit + this.limit
      )
    },
    searchData() {
      this.getInfoAttendance(this.filterObj)
    },
    exportExcel() {
      const tHeader = [
        '日期',
        '签到出勤状态',
        '课耗状态',
        '对应扣费方式',
        '班主任',
        '对应套餐名称',
        '对应订单编号'
      ]
      const filterVal = [
        'create_time',
        'type',
        'consume_day',
        'timer_status',
        'headmaster_name',
        'selling_item_display',
        'billing_id'
      ]
      let list = JSON.stringify(this.itemList)
      list = JSON.parse(list)
      list.forEach(e => {
        e.create_time = e.create_time.substr(0, 11)
        e.type =
          e.type == 'not_in'
            ? '未签到'
            : e.type == 'hold'
              ? '待开课'
              : e.type == 'pause'
                ? '请假'
                : e.type == 'stop'
                  ? '停课'
                  : '已签到'
        e.consume_day = e.consume_day == 1 ? '已消耗' : '未消耗'
        e.timer_status = e.timer_status == 1 ? '月扣' : '日扣'
      })
      Tool.exportExcel(tHeader, filterVal, list, '出勤&课耗详情')
    }
  }
}
</script>
<style lang="scss" scoped>
.attendance-details {
  .table-main {
    .table-header {
      padding-top: 30px;
      .table-header-picker {
        margin-bottom: 30px;
        .el-input {
          width: 140px;
          ::v-deep .el-input__inner {
            border-color: $color_blue;
          }
        }
        span {
          color: $color_black;
          font-size: 14px;
          margin-right: 20px;
        }
        i {
          margin: 0 20px;
          font-size: 18px;
          font-style: normal;
        }
        .el-button {
          width: 90px;
          height: 40px;
          margin-left: 20px;
          &.el-button--success {
            width: 120px;
          }
        }
        .filter-notice {
          font-size: 12px;
          margin-top: 20px;
        }
      }
      .table-header-pagination {
        margin-bottom: 30px;
        flex-wrap: wrap;
        justify-content: space-between;
        .header-left-total {
          font-size: 14px;
          line-height: 40px;
          color: $color_black;
          span {
            margin-right: 30px;
          }
        }
      }
    }
  }
  .italic-gray {
    color: $color_normal !important;
    font-style: italic;
  }
}
</style>
